import React from 'react'
import { Box, Button, Typography } from '@mui/material'

const COPY: Record<string, { title: string; body: string }> = {
  'template-preview': {
    title: 'Preview only',
    body:
      'This link appears in the company invitation email preview. It is not a real invitation and cannot sign you in. To test accepting an invitation, use Company Management and send a real invite to a test address.',
  },
  'template-test': {
    title: 'Test email only',
    body:
      'This link was inserted by a test send from Email Templates. It is not tied to a real user in the database and cannot sign you in. Use Company Management → Invite user to exercise the full accept-invitation flow.',
  },
  'email-tester': {
    title: 'Email tester only',
    body:
      'This link comes from the admin email tester. It is not a redeemable company invitation. Use Company Management to send a real invite if you need to test sign-in from an invitation.',
  },
}

function defaultCopy(source: string | null) {
  if (source && COPY[source]) return COPY[source]
  return {
    title: 'Not a real invitation',
    body:
      'This URL is only for email layout and testing. It cannot accept you into a company. Ask an administrator to resend a real invitation or use Company Management to invite a test user.',
  }
}

/**
 * Shown when users open /invitation-email-preview (e.g. from template preview/test mail).
 */
export default function InvitationEmailPlaceholderPage() {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')
  const source = params.get('source')
  const { title, body } = defaultCopy(source)

  const goSignIn = () => {
    window.history.replaceState({}, document.title, '/')
    window.location.reload()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        bgcolor: 'background.default',
        color: 'text.primary',
        p: 3,
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
      }}
    >
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 600, textAlign: 'center' }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ maxWidth: 440, textAlign: 'center', color: 'text.secondary', mb: 3 }}
      >
        {body}
      </Typography>
      <Button variant="contained" color="primary" onClick={goSignIn} fullWidth sx={{ maxWidth: 360 }}>
        Go to sign in
      </Button>
    </Box>
  )
}
